import { IconTypes } from '@eika/icon';
const personalInsuranceProducts = {
    S10: {
        name: 'Barne- og ungdomsforsikring',
        url: 'barn-og-ungdom-gml',
        icon: IconTypes.BARN_36,
    },
    S12: {
        name: 'Barne- og ungdomsforsikring',
        url: 'barn-og-ungdom',
        icon: IconTypes.BARN_36,
    },
    S20: {
        name: 'Dødsfallkapital',
        url: 'dodsfallkapital',
        icon: IconTypes.DODSFALL_36,
    },
    S30: {
        name: 'Uførekapital',
        url: 'uforekapital',
        icon: IconTypes.HELSE_36,
    },
    S40: {
        name: 'Uførekapital med forskuttering',
        url: 'uforekapital-forskuttering',
        icon: IconTypes.HELSE_36,
    },
    S50: {
        name: 'Uførepensjon',
        url: 'uforepensjon',
        icon: IconTypes.HELSE_36,
    },
    S60: {
        name: 'Fire års uførerente',
        url: 'fire-aars-uforerente',
        icon: IconTypes.HELSE_36,
    },
    S70: {
        name: 'Operasjonsforsikring',
        url: 'operasjonsforsikring',
        icon: IconTypes.LEGE_36,
    },
    S80: {
        name: 'Kritisk sykdom',
        url: 'kritisk-sykdom',
        icon: IconTypes.LEGE_36,
    },
};
export default personalInsuranceProducts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGVyc29uYWxJbnN1cmFuY2VQcm9kdWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy91dGlscy9pbnN1cmFuY2UvcGVyc29uYWxJbnN1cmFuY2VQcm9kdWN0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBS3ZDLE1BQU0seUJBQXlCLEdBQTJEO0lBQ3RGLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSw2QkFBNkI7UUFDbkMsR0FBRyxFQUFFLG9CQUFvQjtRQUN6QixJQUFJLEVBQUUsU0FBUyxDQUFDLE9BQU87S0FDMUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsNkJBQTZCO1FBQ25DLEdBQUcsRUFBRSxnQkFBZ0I7UUFDckIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxPQUFPO0tBQzFCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGlCQUFpQjtRQUN2QixHQUFHLEVBQUUsaUJBQWlCO1FBQ3RCLElBQUksRUFBRSxTQUFTLENBQUMsV0FBVztLQUM5QjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxjQUFjO1FBQ3BCLEdBQUcsRUFBRSxjQUFjO1FBQ25CLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtLQUMzQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxnQ0FBZ0M7UUFDdEMsR0FBRyxFQUFFLDRCQUE0QjtRQUNqQyxJQUFJLEVBQUUsU0FBUyxDQUFDLFFBQVE7S0FDM0I7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsY0FBYztRQUNwQixHQUFHLEVBQUUsY0FBYztRQUNuQixJQUFJLEVBQUUsU0FBUyxDQUFDLFFBQVE7S0FDM0I7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUscUJBQXFCO1FBQzNCLEdBQUcsRUFBRSxzQkFBc0I7UUFDM0IsSUFBSSxFQUFFLFNBQVMsQ0FBQyxRQUFRO0tBQzNCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLHNCQUFzQjtRQUM1QixHQUFHLEVBQUUsc0JBQXNCO1FBQzNCLElBQUksRUFBRSxTQUFTLENBQUMsT0FBTztLQUMxQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsR0FBRyxFQUFFLGdCQUFnQjtRQUNyQixJQUFJLEVBQUUsU0FBUyxDQUFDLE9BQU87S0FDMUI7Q0FDSixDQUFDO0FBRUYsZUFBZSx5QkFBeUIsQ0FBQyJ9